import React from 'react';
import PropTypes from 'prop-types';

export default function Colophon({ siteTitle, siteAuthor, siteAuthorUrl }) {
  return (
    // <div className="w-full bg-brand-blue-900 p-6 text-white">
    <div className="absolute bottom-0 w-full border-t border-secondary bg-primary p-6 text-white">
      <div className="mx-auto md:max-w-3xl lg:max-w-5xl">
        <div className="flex flex-col text-center md:flex-row md:justify-between">
          <div className="mt-6 text-sm text-white md:mt-0">
            <p>
              Copyright {new Date().getFullYear()} &copy; {siteTitle}{' '}
            </p>
          </div>
          <div>
            <p className='className="mt-6 md:mt-0" text-sm text-white'>
              Designed by <a href={siteAuthorUrl}>{siteAuthor}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

Colophon.propTypes = {
  siteTitle: PropTypes.string,
  siteAuthor: PropTypes.string,
  siteAuthorUrl: PropTypes.string,
};

Colophon.defaultProps = {
  siteTitle: ``,
  siteAuthor: `Author`,
  siteAuthorUrl: '#',
};
